import { Table, TableBody } from "@mui/material";
import { StorefrontOutlined as BranchIcon } from "@mui/icons-material";
import type {
  VendorProfileDocument,
  VendorProfileFacility,
  VendorType,
} from "../types";
import { SectionCard } from "../components/SectionCard";
import { FieldRow } from "../components/FieldRow";
import { AttachmentDisplay } from "../components/AttachmentDisplay";
import { formatText } from "../utils/format";
import { findDocument } from "../utils/documentLookup";
import { formatPhone } from "../utils/phone";

type Props = {
  profile: VendorProfileFacility;
  documents: VendorProfileDocument[] | undefined;
  vendorType: VendorType;
};

export function BranchIdentitySection({
  profile,
  documents,
  vendorType,
}: Props) {
  const isGst = vendorType === "GST";
  const isNonGst = vendorType === "Non-GST";
  const isInternational = vendorType === "International";
  const gstCert = findDocument(
    documents,
    "facility",
    profile.id,
    "Facility_GST_Certificate",
  );
  const gstDecl = findDocument(
    documents,
    "facility",
    profile.id,
    "Facility_GST_Declaration",
  );
  const trc = findDocument(
    documents,
    "facility",
    profile.id,
    "Tax_Residency_Certificate",
  );
  const noPe = findDocument(
    documents,
    "facility",
    profile.id,
    "No_PE_Declaration",
  );
  return (
    <SectionCard icon={<BranchIcon fontSize="small" />} title="Branch Details">
      <Table size="small">
        <TableBody>
          <FieldRow label="Branch Name" value={formatText(profile.display_name)} />
          <FieldRow label="Branch Email" value={formatText(profile.email_id)} />
          <FieldRow
            label="Branch Phone"
            value={formatText(formatPhone(profile.mobile_number, profile.mobile_country_code))}
          />
          {!isInternational && (
            <>
              <FieldRow label="GST Number" value={formatText(profile.gst)} />
              <FieldRow
                label="State (from GSTIN)"
                value={formatText(
                  profile.billing_state ?? profile.state_of_registration,
                )}
              />
            </>
          )}
          {isGst && (
            <FieldRow
              label="GST Certificate"
              value={<AttachmentDisplay document={gstCert} />}
            />
          )}
          {isNonGst && (
            <FieldRow
              label="GST Declaration"
              value={<AttachmentDisplay document={gstDecl} />}
            />
          )}
          {isInternational && (
            <>
              <FieldRow
                label="Tax Residency Certificate"
                value={<AttachmentDisplay document={trc} />}
              />
              <FieldRow
                label="No PE Declaration"
                value={<AttachmentDisplay document={noPe} />}
              />
            </>
          )}
        </TableBody>
      </Table>
    </SectionCard>
  );
}

export default BranchIdentitySection;
